import manager from 'ub/fonts/font-service/manager.js';
import googleFontApi from 'ub/fonts/font-service/google/api';
import _ from 'lodash';

const findAndSetFonts = (elementsList) => {
  _.map(elementsList, (element) => {
    return element.style.fontFamily.replace(/'|"/g, '');
  })
    .filter( googleFontApi.isGoogleFont )
    .map( googleFontApi.findFontInList )
    .forEach( (webfont) => {
      manager.addFont({family: webfont.family, variants: webfont.variants}, false);
    });
};

export default function manualFontSetter(contentHtml) {
  const contentElements = manager.getHtmlAsNodeList(contentHtml);
  findAndSetFonts(contentElements.querySelectorAll('[style^=font]'));
}



// WEBPACK FOOTER //
// ./src/ui/inline-text/manual-font-setter.js